var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "error-page" }, [
    _c("h1", { staticClass: "error-page-icon" }, [
      _vm._v("\n    " + _vm._s(_vm.status) + "\n    "),
      _c(
        "svg",
        {
          attrs: {
            viewBox: "0 0 48 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              fill: "#002956",
              "clip-rule": "evenodd",
              d:
                "M23.9978 11.5097C15.4022 11.5097 8.80078 7.99515 3.27151 0.815003C2.66759 0.0326979 1.78062 -0.298033 0.80634 0.326857C0.323092 0.636388 0 1.12665 0 1.65455C0 2.26142 0.299736 2.70134 0.657862 3.2022C6.59141 11.4975 14.0108 16 23.9622 16C34.0926 16 41.4103 11.5108 47.3544 3.18259C47.7214 2.67006 48 2.27573 48 1.65402C48 1.09326 47.6335 0.575436 47.1008 0.271736C46.1593 -0.265172 45.3046 0.0793394 44.7268 0.815003C39.1981 7.99621 32.5244 11.5097 23.9978 11.5097Z"
            }
          })
        ]
      )
    ]),
    _c("p", {
      staticClass: "error-page-title",
      domProps: { textContent: _vm._s(_vm.title) }
    }),
    _vm.status === 404
      ? _c("p", { staticClass: "error-page-subtitle" }, [
          _vm._v("\n    Чтобы найти нужную информацию, воспользуйтесь "),
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.$f.toggleSearch($event)
                }
              }
            },
            [_vm._v("поиском")]
          ),
          _c("br"),
          _vm._v("или перейдите на "),
          _c("a", { attrs: { href: "/" } }, [_vm._v("главную страницу")])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }